import { CREATE_STRATEGY_NOTE_PERMISSION } from './crmStrategyNoteService';
import CreateStrategyNoteForm from './form/CreateStrategyNoteForm';
import UpdateStrategyNoteForm from './form/UpdateStrategyNoteForm';
import StrategyNoteTimelineRecordLayout from './StrategyNoteTimelineRecordLayout';
import { isStrategyTimelineItem } from './types';

const useCrmStrategyNoteItem = () => ({
  AddForm: CREATE_STRATEGY_NOTE_PERMISSION ? CreateStrategyNoteForm : undefined,
  UpdateForm: UpdateStrategyNoteForm,
  isApplicable: isStrategyTimelineItem,
  source: 'strategyNote',
  urlPostfix: 'strategy-notes',
  RecordLayout: StrategyNoteTimelineRecordLayout,
  name: 'Strategy',
  buttonSize: 'small',
  permissionToCheck: CREATE_STRATEGY_NOTE_PERMISSION,
  hideAddWhenItemExists: true,
});

export default useCrmStrategyNoteItem;
